import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import {
	AUTO_LOGIN_ATTEMPTED_KEY,
	EXPLICIT_SIGNOUT_KEY,
	POST_AUTH_REDIRECT_KEY
} from './auth.keys';
import { AuthService } from './auth.service';

export const AuthGuard: CanActivateFn = (_route, state) => {
	const authService = inject(AuthService);
	const status = authService.status();

	if (status === 'authenticated') {
		return true;
	}
	// Indeterminate: Tier 1 owns recovery. Auto-redirecting here is how a loop starts.
	if (status === 'failed') {
		return false;
	}
	// The user asked to be signed out. Landing them on the signed-out card is the whole point.
	if (sessionStorage.getItem(EXPLICIT_SIGNOUT_KEY)) {
		return false;
	}
	// One attempt per browsing session. Where localStorage is unavailable or evicted — iOS
	// private browsing, post-storage-clear — MSAL cannot persist the account, so every return
	// lands here and an unlatched trigger redirects forever.
	if (sessionStorage.getItem(AUTO_LOGIN_ATTEMPTED_KEY)) {
		authService.markFailed();
		return false;
	}

	sessionStorage.setItem(AUTO_LOGIN_ATTEMPTED_KEY, '1');
	localStorage.setItem(POST_AUTH_REDIRECT_KEY, state.url);
	authService.login().subscribe({
		error: () => authService.markFailed()
	});
	return false;
};
